import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class IrvBorcKontrolAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "IrvBorcKontrol";
        super(baseUrl);
    }
    getIrvBorcKontrol(SqId: number, Durum: number) {
        var request = new IrvBorcKontrolRequest(SqId, Durum);

        return this.post("", request, false);
    }
}
export default new IrvBorcKontrolAPI();
class IrvBorcKontrolRequest {
    public sqId: number;
    public durum: number;

    constructor(sqId: number, durum: number) {

        this.sqId = sqId;
        this.durum = durum;

    }
}
export { IrvBorcKontrolRequest };